"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quotePropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const quotePropDefs = {
    asChild: index_js_1.asChildProp,
};
exports.quotePropDefs = quotePropDefs;
//# sourceMappingURL=quote.props.js.map